import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import InterestItem from './InterestItem';
import { useDeleteInterestMutation } from '../endpoints/discovery';
import noInterestsLogo from '../assets/img/discovery_prompt_no_interests.svg';
import EmptyPrompt from './EmptyPrompt';

const InterestManager = ({
  discoveryItems,
  setDiscoveryItems,
  editInterest,
  interestsData,
  isInterestsLoading,
}) => {
  const auth = useSelector((state) => state.auth);
  const [deleteInterestById] = useDeleteInterestMutation();

  useEffect(() => {
    setDiscoveryItems(
      interestsData?.map((item) => ({
        ...item,
      }))
    );
  }, [isInterestsLoading, interestsData]);

  const deleteInterest = (itemId) => {
    deleteInterestById({ id: itemId });
    setDiscoveryItems(discoveryItems.filter((item) => item.id !== itemId));
  };

  if (isInterestsLoading)
    return (
      <EmptyPrompt
        svgLink={noInterestsLogo}
        description="Please wait while Consili finds your insights..."
      />
    );
  if (!auth.demo && !discoveryItems?.length)
    return (
      <EmptyPrompt
        svgLink={noInterestsLogo}
        description="Add your interests to get started"
      />
    );

  return (
    <>
      {discoveryItems
        ?.slice()
        .sort((a, b) => b.id - a.id)
        .map((item) => (
          <InterestItem
            key={item.id}
            item={item}
            onDelete={deleteInterest}
            onEdit={(itemId, updatedInterest) =>
              editInterest(itemId, updatedInterest)
            }
            updateEdit={(itemId, updatedInterest) =>
              editInterest(itemId, updatedInterest)
            }
          />
        ))}
    </>
  );
};

export default InterestManager;
